import { css } from 'styled-components';

// workaround since css<> loses the intellisense for css
const styled = { css };

export const COLORS = {
  white: 'var(--white)',
  primary: 'var(--main)',
  secondary: 'var(--secondary)',
  gray: 'var(--gray4)',
  grayText: 'var(--gray4c)',
  yellow: 'var(--yellow4)',
  // Default theme link color
  theme: 'var(--link)',
  light: 'var(--mainLight)',
  blue: 'var(--blue3)',
  yellow2: 'var(--yellow2)',
  error: 'var(--error)',
  red: 'var(--error)',
  success: 'var(--success)',
} as const;

const HOVERS = {
  white: 'var(--mainLight)',
  secondary: 'var(--secondaryHover)',
} as const;

export type CommonLinkProps = {
  /**
   * The link color which is either the predefined values converted to var() or any css valid color
   * */
  color?: keyof typeof COLORS | 'inherit';
  $underline?: boolean;
  $nowrap?: boolean;
  disabled?: boolean;
  /** Center content of link by using Flexbox */
  $alignCenter?: boolean;
};

const disabledStyle = css`
  color: var(--gray3);
  cursor: not-allowed;
`;

export const commonLinkStyle = styled.css<CommonLinkProps>`
  ${({ color }) =>
    color ? `color: ${COLORS[color as keyof typeof COLORS] || color};` : ''}
  text-decoration: ${({ $underline }) => ($underline ? 'underline' : 'none')};
  transition: filter 0.2s ease;
  ${({ $nowrap }) => ($nowrap ? 'white-space: nowrap;' : '')}
  ${({ disabled }) => (disabled ? disabledStyle : '')}
  &:hover {
    ${({ color }) =>
      color && HOVERS[color as keyof typeof HOVERS]
        ? `color: ${HOVERS[color as keyof typeof HOVERS]};`
        : 'filter: brightness(120%);'}
  }

  ${({ $alignCenter }) =>
    $alignCenter ? `display: inline-flex; align-items: center;` : ''}
`;
